module.exports = __webpack_public_path__ + "static/media/pr_details1.b8070c6b.jpg";